<script lang="ts" setup>
import type { Signet } from '@/libs/api/connect/connect.types.ts'
import { computed } from 'vue'

type Props = {
  signets?: Signet[]
}
const props = defineProps<Props>()

const signets = computed(() => {
  return (
    props.signets?.map((signet) => ({
      img: signet.img,
      alt: signet.alt
    })) ?? []
  )
})
</script>

<template>
  <div class="signets">
    <img
      v-for="(signet, index) in signets"
      :key="`signet${index}`"
      :alt="signet.alt"
      :src="signet.img"
    />
  </div>
</template>

<style lang="scss" scoped>
@import 'signet-group';
</style>
